import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.applyStyle()
    }

    applyStyle() {
        const senderId = parseInt(this.element.dataset.senderId, 10)
        const currentUserId = this.getCurrentUserId()

        // If I am the sender, apply "Sent" styles
        if (currentUserId && senderId === currentUserId) {
            this.element.classList.remove("justify-start")
            this.element.classList.add("justify-end")

            const bubble = this.element.querySelector(".rounded-tl-sm") // Identifier for received bubble
            if (bubble) {
                // Remove received classes
                bubble.classList.remove("bg-white", "text-gray-800", "border", "border-gray-100", "rounded-tl-sm")

                // Add sent classes
                bubble.classList.add("bg-gradient-to-br", "from-orange-400", "to-orange-500", "text-white", "rounded-tr-sm", "shadow-md", "border-0")

                // Fix timestamps
                const timestampContainer = this.element.querySelector(".text-[10px]").parentElement
                if (timestampContainer) {
                    timestampContainer.classList.remove("justify-start")
                    timestampContainer.classList.add("justify-end")
                }
            }
        }
    }

    getCurrentUserId() {
        const metaTag = document.querySelector('meta[name="current-user-id"]') || document.querySelector('meta[name="user-id"]')
        return metaTag ? parseInt(metaTag.content, 10) : null
    }
}
